import StatCard from "../components/StatCard";

export default function Certificates() {
  return (
    <div className="pageDashB">
      <h2 className="dashboardPageTitleFont">My certificates statistics</h2>

      <div className="stats-grid">
        <StatCard title="Certificates" value="0" />
        <StatCard title="Average Grade" value="0" />
        <StatCard title="Failed Quizzes" value="0" />
      </div>

      <div className="form-card">
        <h3>Filter certificates</h3>
        <div className="filter-row">
          <input type="date" />
          <input type="date" />
          <select><option>All Courses</option></select>
          <select><option>All Quizzes</option></select>
          <button>Show Results</button>
        </div>
      </div>
    </div>
  );
}
